function HistoryScroll(){
    let element = document.getElementById("pulls");   
    element.scrollTop = element?.scrollHeight
}

export default HistoryScroll